import Layout from '././views/home-page/layout';
// 拖车运价 货车位置海运管家行业百科快递查询订单中心关于我们
export default [
    {
        path: '/default',
        icon: 'navigate',
        name: 'default',
        component: Layout,
        children: [
            {
                path: '/new-index',
                title: '首页',
                name: 'new-index',
                component: resolve => {
                    require([
                        './views/home-page/default/default.vue'
                    ], resolve);
                }
            },
            {
                path: '/index',
                title: '首页',
                name: 'index',
                component: resolve => {
                    require([
                        // './views/home-page/default/default.vue'
                        './views/home-page/default/default-new.vue'
                    ], resolve);
                }
            },
            
            {
                path: '/articles',
                title: '新闻中心',
                name: 'articles',
                component: resolve => {
                    require([
                        './views/home-page/article/articles.vue'
                    ], resolve);
                }
            },
            {
                path: '/about',
                title: '关于我们',
                name: 'about',
                component: resolve => {
                    require([
                        './views/home-page/about-duckbill/about-duckbill.vue'
                    ], resolve);
                }
            },
            {
                path: '/excess',
                title: '超额审批列表',
                name: 'excess',
                component: resolve => {
                    require([
                        './views/home-page/excess/excess.vue'
                    ], resolve);
                }
            },
            {
                path: '/peakSeasonQuota',
                title: '旺季超额通知客户改期',
                name: 'peakSeasonQuota',
                component: resolve => {
                    require([
                        './views/home-page/peak-season-quota/index.vue'
                    ], resolve);
                }
            },
            {
                path: '/linkApplyQuota',
                title: '客户申请旺季额度',
                name: 'linkApplyQuota',
                component: resolve => {
                    require([
                        './views/home-page/link-apply-quota/index.vue'
                    ], resolve);
                }
            },
            {
                path: '/news',
                title: '文章详情',
                name: 'news',
                component: resolve => {
                    require([
                        './views/home-page/news-detail/news-detail.vue'
                    ], resolve);
                }
            },
            {
                path: '/courier-query',
                title: '快递查询',
                name: 'courier-query',
                component: resolve => {
                    require(['./views/home-page/courier-query/courier-query.vue'], resolve);
                }
            },
            {
                path: '/LCL',
                title: '进口拼箱',
                name: 'LCL',
                component: resolve => {
                    require(['./views/LCL/LCL.vue'], resolve);
                }
            },
            {
                path: '/server-product',
                title: '服务产品',
                name: 'server-product',
                component: resolve => {
                    require(['./views/server-product/server-product.vue'], resolve);
                }
            },
            {
                path: '/service-advisory',
                title: '服务产品',
                name: 'service-advisory',
                component: resolve => {
                    require(['./views/service-advisory/service-advisory.vue'], resolve);
                }
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/homePageRouter.js